/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';
//import { getCall } from '../../utils/axios';
import CookiesService from '../../shared/CookiesService';
import APIEndpoints from '../../api/APIEndpoints';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import { axiosInstance } from '../../../api/axios';
import { ArrowIcon } from 'src/Admin/img/Admin/BreadCrumbIcons';
import { getMemberDetailsByOidAndType } from 'src/redux/admin/api-calls/members';

export default function ReadonlyBreadCrumb({ isVisible }) {
  const [breadcrumData, setBreadcumData] = useState(null);
  const GetUser = async () => {
    //const responseOld = await axiosInstance.get(
    //APIEndpoints.GetMember() +
    //CookiesService.get('MemberUserType') +
    //'/oid/' +
    //CookiesService.get('MemberOid'),
    //);

    const response = await getMemberDetailsByOidAndType(
      CookiesService.get('MemberOid'),
      CookiesService.get('MemberUserType'),
    );

    if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
      const { BlockOfBusinessName, ClientName, LocationName } =
        response.data.Response.Member;
      setBreadcumData({
        BlockOfBusinessName,
        ClientName,
        LocationName,
      });
    }
  };

  useEffect(() => {
    GetUser();
  }, []);

  return (
    //<div class="disable-breadcrum">
    <div className={isVisible ? 'd-block' : 'd-none'}>
      {breadcrumData ? (
        <Breadcrumb>
          <>
            <Breadcrumb.Item>
              {breadcrumData?.BlockOfBusinessName}
            </Breadcrumb.Item>
            <span className={'px-2'}>
              <ArrowIcon className="arrow-breadcrumb-icon" />
            </span>
          </>
          {breadcrumData?.ClientName && (
            <>
              <Breadcrumb.Item>{breadcrumData?.ClientName}</Breadcrumb.Item>
              <span className={'px-2'}>
                <ArrowIcon className="arrow-breadcrumb-icon" />
              </span>
            </>
          )}
          {breadcrumData?.LocationName && (
            <>
              <Breadcrumb.Item>{breadcrumData?.LocationName}</Breadcrumb.Item>
            </>
          )}
        </Breadcrumb>
      ) : null}
    </div>
  );
}
